import { NavGroup } from '@/components/sidebar/NavGroup';
import { SidebarBanner } from '@/components/sidebar/SidebarBanner';
import { UserMenu } from '@/components/sidebar/UserMenu';
import { useNavSections } from '@/components/sidebar/nav-config';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from '@/components/ui/sidebar';
import { Link } from 'react-router-dom';

export function AppSidebar() {
  const sections = useNavSections();

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader className="h-12 justify-center px-2 py-0">
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild tooltip="Cotality Marketplace">
              <Link to="/dashboard" className="font-semibold text-sidebar-foreground">
                <img
                  src="/cotality-logomark.png"
                  alt=""
                  aria-hidden="true"
                  className="h-8 w-8 shrink-0 dark:invert"
                />
                <span className="truncate group-data-[collapsible=icon]:hidden">
                  Cotality Marketplace
                </span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        {sections.map((section, index) => (
          <NavGroup key={section.label ?? `section-${String(index)}`} {...section} />
        ))}
      </SidebarContent>
      <SidebarBanner />
      <SidebarFooter>
        <UserMenu variant="expanded" />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
